import { getAuthOrigin } from '@/lib/auth-client';
import { getCashierUrl, getDashboardUrl } from '@/components/theme-provider';

export type HomeLink =
  { kind: 'cashier'; url: string; labelKey: string } | { kind: 'dashboard'; url: string | undefined; labelKey: string };

/**
 * Where "back", logout and re-auth send this tab: the cashier when the cashier opened the
 * session (`from=cashier`) and VITE_CASHIER_URL is set, otherwise the dashboard as always.
 */
export function getHomeLink(): HomeLink {
  const cashierUrl = getAuthOrigin() === 'cashier' ? getCashierUrl() : undefined;
  if (cashierUrl) return { kind: 'cashier', url: cashierUrl, labelKey: 'header.backToCashier' };
  return { kind: 'dashboard', url: getDashboardUrl(), labelKey: 'header.goToDashboard' };
}
